/**
 * Syntagma Redesign — Typewriter + Key Figures Counter
 */
(function ($) {
    'use strict';

    // ─── Typewriter Effect ───
    function initTypewriter() {
        var el = document.querySelector('.hero-video__typewriter');
        if (!el) return;

        var sentences = [];
        try {
            sentences = JSON.parse(el.getAttribute('data-sentences'));
        } catch (e) {
            return;
        }

        if (!sentences.length) return;

        var textEl = el.querySelector('.hero-video__typewriter-text');
        var cursorEl = el.querySelector('.hero-video__cursor');
        var currentIndex = 0;
        var charIndex = 0;
        var isDeleting = false;
        var typeSpeed = 60;
        var deleteSpeed = 35;
        var pauseDuration = 2000;

        function tick() {
            var current = sentences[currentIndex];

            if (!isDeleting) {
                // Typing
                charIndex++;
                textEl.textContent = current.substring(0, charIndex);

                if (charIndex >= current.length) {
                    // Done typing, pause then delete
                    setTimeout(function () {
                        isDeleting = true;
                        tick();
                    }, pauseDuration);
                    return;
                }

                setTimeout(tick, typeSpeed);
            } else {
                // Deleting
                charIndex--;
                textEl.textContent = current.substring(0, charIndex);

                if (charIndex <= 0) {
                    isDeleting = false;
                    currentIndex = (currentIndex + 1) % sentences.length;
                    setTimeout(tick, typeSpeed * 2);
                    return;
                }

                setTimeout(tick, deleteSpeed);
            }
        }

        // Start after a small delay
        setTimeout(tick, 500);
    }

    // ─── Key Figures Counter ───
    function initCounters() {
        var counters = document.querySelectorAll('.key-figures__number[data-count-to]');
        if (!counters.length) return;

        var duration = 2000; // All counters finish in 2 seconds
        var observed = false;

        function animateCounter(el) {
            var target = parseFloat(el.getAttribute('data-count-to'));
            if (isNaN(target)) return;

            var isDecimal = target % 1 !== 0;
            var noSeparator = el.hasAttribute('data-no-separator');
            var startTime = null;

            function easeOutExpo(t) {
                return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
            }

            function formatNumber(num) {
                if (isDecimal) {
                    return num.toFixed(1);
                }
                if (num >= 1000 && !noSeparator) {
                    return Math.round(num).toLocaleString('en-US');
                }
                return Math.round(num).toString();
            }

            function step(timestamp) {
                if (!startTime) startTime = timestamp;
                var progress = Math.min((timestamp - startTime) / duration, 1);
                var easedProgress = easeOutExpo(progress);
                var currentValue = target * easedProgress;

                el.textContent = formatNumber(currentValue);

                if (progress < 1) {
                    requestAnimationFrame(step);
                } else {
                    el.textContent = formatNumber(target);
                }
            }

            requestAnimationFrame(step);
        }

        // Use IntersectionObserver
        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting && !observed) {
                        observed = true;
                        counters.forEach(function (counter) {
                            animateCounter(counter);
                        });
                        observer.disconnect();
                    }
                });
            }, { threshold: 0.2 });

            // Observe the container
            var container = document.querySelector('.key-figures__grid');
            if (container) {
                observer.observe(container);
            }
        } else {
            // Fallback: animate immediately
            counters.forEach(function (counter) {
                animateCounter(counter);
            });
        }
    }

    // ─── Hero scroll-to-content ───
    function initHeroScroll() {
        var scrollBtn = document.querySelector('.hero-video__scroll-to-content');
        if (!scrollBtn) return;

        scrollBtn.addEventListener('click', function () {
            var hero = document.querySelector('.hero-video');
            if (!hero) return;
            var nextSection = hero.nextElementSibling;
            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    // ─── Initialize ───
    $(document).ready(function () {
        initTypewriter();
        initCounters();
        initHeroScroll();
    });

})($);
